import React, { useState } from "react";
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import NumberFormat from 'react-number-format';
import { actionTypes } from "../reducer";
import { useStateValue } from "../StateProvider";
import format from "date-fns/format";


export const useInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const [{ applicantDetails }, dispatch] = useStateValue();

  const updateField = (e) => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        [e.target.name]: e.target.value,
      },
    });
  }

  return {
    value,
    setValue,
    reset: () => setValue(""),
    bind: {
      value,
      onChange: (event) => {
        setValue(event.target.value);
      },
      // onBlur: (event) => {
      //   //updateField(event);
      // }
    },
  };
};

export const useSwitch = (initialValue, apiCall = null) => {
  const [checked, setChecked] = useState(initialValue);



  return {
    checked,
    setChecked,
    reset: () => setChecked(false),
    bind: {
      checked,
      onChange: (event) => {
        if (apiCall != null) {
          apiCall(event.target.checked);
        }
        else {
          setChecked(event.target.checked);
        }
      },
    },
  };
};


export const TextMaskCustomPhone = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomPhone.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


export const TextMaskCustomYear = React.forwardRef(function TextMaskCustomYear(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={Date}
      pattern={'YYYY'}
      min={new Date(1900, 0, 1)}
      max={new Date()}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomYear.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomDate = React.forwardRef(function TextMaskCustomDate(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={Date}
      pattern={'m/`d/`YYYY'}
      min={new Date(1900, 0, 1)}
      max={new Date()}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomDate.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomDateNoMax = React.forwardRef(function TextMaskCustomDate(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={Date}
      pattern={'m/`d/`YYYY'}
      min={new Date(1900, 0, 1)}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomDateNoMax.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

//(NNN-NN-NNNN

export const TextMaskCustomTaxID = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      autoComplete="new-password"
      {...other}
      autoComplete="new-password"
      mask="##-#######"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomTaxID.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomSSN = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      autoComplete="new-password"
      {...other}
      mask="###-##-####"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomSSN.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomZipCode = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="#####"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomZipCode.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomMCDOT = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="######"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite={false}
    />
  );
});

TextMaskCustomMCDOT.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustom0to99 = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="##"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom0to99.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomPercent = React.forwardRef(function TextMaskCustomPhone(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={Number}
      scale={2}
      min={0}
      max={100}
      radix={"."}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustomPercent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const TextMaskCustomEmail = React.forwardRef(function TextMaskCustomEmail(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      autoComplete="off"
      mask={/^\S*@?\S*$/}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
    />
  );
});

TextMaskCustomEmail.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


export const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


export const BoolConverter = (strValue) => {
  if (strValue == "yes") {
    return "true"
  }
  else if (strValue == "true") {
    return "Yes"
  }
  else if (strValue == "no") {
    return "false"
  }
  else if (strValue == "false") {
    return "no"
  }
}